//
import Model from '@/models/Model'
import ACustomerCreditModel from '@/models/Actions/ACustomerCredit'

//
export default class SlCustomerBranchOffices extends Model {

  /**
   * { function_description }
   * @return     {<type>}  { description_of_the_return_value }
   */
  customerCredit() {
    return this.hasMany(ACustomerCreditModel)
  }

  /**
   * { function_description }
   * @return     {string}  { description_of_the_return_value }
   */
  resource() {
    return 'sl_customer_branch_offices'
  }

  /**
   * Returns a customer credit representation of the object.
   * @return     {<type>}  Customer credit representation of the object.
   */
  toCustomerCredit() {
  	return this.clean([
  		'max_customer_credit',
  		'slack_customer_credit',
  	])
  }
}